import { render, staticRenderFns } from "./EmployeeStat.vue?vue&type=template&id=037994f8&scoped=true&"
import script from "./EmployeeStat.vue?vue&type=script&lang=js&"
export * from "./EmployeeStat.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeStat.vue?vue&type=style&index=0&id=037994f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037994f8",
  null
  
)

export default component.exports